
import React, { useState, useEffect } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { useApp } from '../AppContext';

const Hero: React.FC = () => {
  const { siteSettings } = useApp();
  const [current, setCurrent] = useState(0);

  const slides = siteSettings.heroSlides;

  const next = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(next, 8000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-[600px] sm:h-[700px] overflow-hidden group">
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${idx === current ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
        >
          {/* Overlay */}
          <div className={`absolute inset-0 bg-black/40 dark:bg-black/60 z-20`} />
          
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover scale-110 animate-slow-zoom"
          />

          <div className="absolute inset-0 z-30 flex items-center">
            <div className="container mx-auto px-4 sm:px-8">
              <div className={`max-w-2xl text-white transition-all duration-700 delay-300 transform ${idx === current ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
                <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
                  {slide.subtitle}
                </span>
                <h1 className="text-5xl sm:text-7xl font-bold font-serif mb-6 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-lg sm:text-xl text-slate-200 mb-8 max-w-lg">
                  {slide.description}
                </p>
                <div className="flex flex-wrap gap-4">
                  <button className="px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full font-bold flex items-center gap-2 transition-all group/btn">
                    Shop Collection
                    <ArrowRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
                  </button>
                  <button className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border border-white/30 rounded-full font-bold transition-all">
                    Explore More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Nav Controls */}
      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-40 p-2 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <ChevronLeft className="w-8 h-8" />
      </button>
      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-40 p-2 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <ChevronRight className="w-8 h-8" />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-40 flex gap-2">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`h-1.5 rounded-full transition-all ${idx === current ? 'w-8 bg-white' : 'w-4 bg-white/40'}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
